import { useStorage } from '@vueuse/core'
import fp from '~/composables/useFingerprint'
import pkg from '../../package.json'

export async function getReqHeaders() {
  // Base headers
  const config: Record<string, any> = {
    'lang': 'zh-CN',
    'version': pkg.version,
    'Accept-Date': currentTimeZone(),
    'Device': '',
  }

  // Derive language safely without requiring Nuxt app context on server
  try {
    // Prefer i18n cookie set by @nuxtjs/i18n on client
    // eslint-disable-next-line node/prefer-global/process
    if (process.client) {
      const m = document.cookie?.match(/(?:^|; )i18n_redirected=([^;]+)/)
      const locale = m ? decodeURIComponent(<string>m[1]) : (document.documentElement.lang || 'zh')
      config.lang = locale === 'zh' ? 'zh-CN' : 'en-US'
    }
  }
  catch {}

  // Attach device info only on client
  try {
    // eslint-disable-next-line node/prefer-global/process
    if (process.client)
      config.Device = await fp.getDeviceInfo()
  }
  catch {}

  // Optional source info from storage (client only)
  try {
    // eslint-disable-next-line node/prefer-global/process
    if (process.client) {
      const sourceCache = useStorage('SOURCE', { val: '' })
      if (sourceCache?.value?.val)
        config.source = sourceCache.value.val
    }
  }
  catch {}

  return config
}
